import React, { MutableRefObject, useEffect, useRef } from 'react';
import { initSceneAndAnimate } from './threeMain';
import { MediaPipePredictor } from './mediaPipePredictor';

export let video: HTMLVideoElement; 

function App() {
  const canvasRef: MutableRefObject<HTMLCanvasElement  | undefined> = useRef();
  const videoRef: MutableRefObject<HTMLCanvasElement  | undefined> = useRef();
  const created : MutableRefObject<boolean | undefined> = useRef();
  useEffect(() => {
    if(!created.current){
      created.current = true;
      video= videoRef.current as unknown as HTMLVideoElement;
      initSceneAndAnimate(canvasRef.current!);
      window.APP!.mediaPipePredictor = new MediaPipePredictor();
      window.APP!.mediaPipePredictor.setup(video);
    }
  },[])
  return (
    <>
      <video ref={videoRef as any} className='hidden absolute w-10 h-10' id="video" autoPlay/>
      <canvas ref={canvasRef as any} className='w-full h-full bg-transparent'/>
    </>
  );
}

export default App;
